import React from 'react';
import { useHistory } from 'react-router-dom';
import {
  DashboardBannerCard,
  DashboardCards
} from 'components/DashboardCarousel/DashboardBannerCard';

export interface Props {
  data: {
    onAnalyticsClick: () => void;
  };
  totalCards: number;
}

const DashboardCarouselNewAppAnnouncement = (props: Props) => {
  const history = useHistory();
  const { onAnalyticsClick } = props.data;

  return (
    <DashboardBannerCard
      title="New Intermountain Health App coming September 2025!"
      actionOne={{
        text: 'Get Ready Now',
        onClick: () => {
          onAnalyticsClick();
          history.push('/u/dashboard', { showAppAnnounementDetails: 'true' });
        }
      }}
      imageName={DashboardCards.newAppAnnouncement.imageName}
      textColor={DashboardCards.newAppAnnouncement.color}
      background={DashboardCards.newAppAnnouncement.background}
      totalCards={props.totalCards}
    />
  );
};

export default DashboardCarouselNewAppAnnouncement;
